import diskonCardHomepage from '../images/diskonCardHomepage.webp';

const DiskonCardHomepage = () => {
  return (
    <img
      src={diskonCardHomepage.src}
      width="292"
      height="333"
      alt="diskon card"
      className="w-full h-full object-cover"
      loading="lazy"
    />
  );
};

export { DiskonCardHomepage };
